import { useQuery } from "@tanstack/react-query";

import TokenHelper from "@/utils/tokenHelper";
import { QUERY_KEYS } from "@api/queryKeys";

import {
  adaptTopicType,
  adaptTopicTypeName,
} from "./adaptPublicationTopicType.data";
import { publicationTopicTypeApi } from "./publicationTopicType.service";

export const useTopicTypeQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.publicationTopicType],
    queryFn: () => publicationTopicTypeApi.getTopicTypeData(),
    throwOnError: false,
    select: (data) => adaptTopicType(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};

export const useTopicTypeNameQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  const query = useQuery({
    queryKey: [QUERY_KEYS.publicationTopicType],
    queryFn: () => publicationTopicTypeApi.getTopicTypeData(),
    throwOnError: false,
    select: (data) => adaptTopicTypeName(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });
  return query;
};
